import React, { useEffect } from "react";
import { Form, Input, Col, Checkbox, Row, Select, Modal } from 'antd';
import ValidatorHelper from "../helpers/ValidatorHelper";
import StringHelper from '../helpers/StringHelper';
import OnlyNumber from "../shared/OnlyNumbers";
import { useReportsStore } from "../../store/slices/createReportsSlice";
import { useGeneralStore } from "../../store/slices/createGeneralSlice";
import { usePersistedStore } from "../../store/persisted-store";

export default function NewUserModal({ mobileNumber }) {
    const { users } = usePersistedStore()
    const [form] = Form.useForm();
    const reports = useReportsStore()
    const general = useGeneralStore()
    const visible = general.view.newUserModal;
    const userBusinesses = users.businesses;
    const reasons = reports.crmCallReasonReport.data.Reasons;
    const MessageTemplatesData = reports.crmSms.data;
    const MessageTemplatesLoading = reports.crmSms.loading;
    const reasonsLoading = reports.crmCallReasonReport.loading;
    const status = reports.crmCallStatusReport.data.Status;
    const statusLoading = reports.crmCallStatusReport.loading;
    const loading = reports.crmCallHistoryReport.loading;
    const callReasonWatcher = Form.useWatch("callReason", form);

    useEffect(() => {
        reports.getCrmCallReasonReport()
        reports.getCrmCallStatusReport()
    }, [])
    useEffect(() => {
        if (callReasonWatcher) {
            reports.getCrmSms(callReasonWatcher)
            form.setFieldsValue({
            MessageTemplate: undefined
        });
        }
    }, [callReasonWatcher])


    function onFinish(values) {

        const mobileNum = StringHelper.getEnglishNum(values.phoneNumber);

        const params = {
            IsProtest: values.IsProtest ? true : false,
            FirstName: values.firstName,
            LastName: values.lastName,
            PhoneNumber: mobileNum,
            BusinessToken: values.businessToken,
            CallStatus: values.callStatus,
            CallReasonId: values.callReason,
            Description: values.description,
            InsuranceRequestId: null,
            MessageTemplateId: values.MessageTemplate
        };
        reports.postCrmCallHistoryReport({
            params
        })
        general.ToggleCrmNewUserModal(false);
        form.resetFields();

        setTimeout(() => {
            reports.getUserBusiness({ mobile: mobileNum })
        }, 1000);
    }

    function onFinishFailed(errorInfo) {
        form.scrollToField(errorInfo.errorFields[0].typeId, {
            scroll: {
                offsetTop: 65,
            },
        });
    }
    useEffect(() => {

        form.setFieldsValue({
            businessToken: "da4aa2f8-70d9-4d56-b577-3162dfae2c0f",
            phoneNumber: mobileNumber ? mobileNumber : ""
        })
    }, [mobileNumber]);

    const itemLayout = {
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
    }

    return (
        <div className="crm-new-user">
            <Modal
                width={800}
                title={"افرودن تماس جدید"}
                className="custom-table crm-request-report "
                open={visible}
                footer={false}
                onCancel={() => general.ToggleCrmNewUserModal(false)}>
                <Form
                    form={form}
                    className="form-style crm-new-user-form "
                    layout="vertical"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}>
                    <Row gutter={[16, 16]}>

                        <Col {...itemLayout}>
                            <Form.Item
                                rules={ValidatorHelper.firstname()}
                                name="firstName"
                                label="نام">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col {...itemLayout}>
                            <Form.Item
                                rules={ValidatorHelper.lastname()}
                                name="lastName"
                                label="نام خانوادگی">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col {...itemLayout}>
                            <Form.Item
                                name="phoneNumber"
                                label="شماره تلفن همراه"
                                rules={ValidatorHelper.mobile("موبایل")}>
                                <Input maxLength={11} type="tel" onKeyPress={e => OnlyNumber(e)} />
                            </Form.Item>
                        </Col>
                        <Col {...itemLayout}>
                            <Form.Item
                                name="businessToken"
                                label="نام بیزینس"
                                placeholder="انتخاب کنید"
                                rules={ValidatorHelper.required("نام بیزینس")}
                            >
                                <Select
                                    filterOption={(input, option) =>
                                        option.props.children.indexOf(input) >= 0
                                    }
                                    showSearch placeholder="انتخاب کنید">
                                    {userBusinesses &&
                                        userBusinesses.map((item) => {
                                            return (
                                                <Select.Option key={item.Token} value={item.Token}>
                                                    {item.Title}
                                                </Select.Option>
                                            );
                                        })}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col {...itemLayout}>
                            <Form.Item
                                name="callStatus"
                                label="وضعیت تماس"
                                placeholder="انتخاب کنید"
                                rules={ValidatorHelper.required("وضعیت تماس")}>
                                <Select disabled={statusLoading} loading={statusLoading} placeholder="انتخاب کنید">
                                    {status && status.map((state) => <Select.Option key={state.Id} value={state.Id}>{state.Title}</Select.Option>)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col {...itemLayout}>
                            <Form.Item
                                name="callReason"
                                label="دلایل تماس"
                                rules={ValidatorHelper.required("دلایل تماس")}>
                                <Select disabled={reasonsLoading} loading={reasonsLoading} placeholder="انتخاب کنید">
                                    {reasons && reasons.map((reason) => <Select.Option key={reason.Id} value={reason.Id}>{reason.Title}</Select.Option>)}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                name="MessageTemplate"
                                label="قالب پیامک"
                                className="custom-select-overFlow"
                                >
                                <Select 
                                style={{ height: 'auto' }}
                                disabled={!callReasonWatcher} loading={MessageTemplatesLoading} placeholder="انتخاب کنید">
                                    {MessageTemplatesData && MessageTemplatesData.map((msg) => <Select.Option key={msg.Id} value={msg.Id} >
                                        <span style={{ whiteSpace: "normal" }}>{msg.Title}</span>
                                    </Select.Option>)}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={24}>

                            <Form.Item name="IsProtest" valuePropName="checked" >
                                <Checkbox>آیا شکایت داری؟</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item name="description" label="توضیحات">
                                <Input.TextArea rows={2} />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item>
                                <button type="primary" className="btn btn-primary waves-effect waves-light float-left">
                                    <i className={loading ? "bx bx-loader bx-spin" : "bx bx-check-double "}></i>
                                    &nbsp;ثبت
                                </button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </div>
    );
}
